import tw from 'tailwind-styled-components'

export const Button = tw.button`
    bg-gradient-to-r-custom rounded-4 p-9 font-semibold
`
